import React, { Suspense } from 'react';

import { HelpLink } from '@components/HelpLink';
import { ServerErrorLayout } from '@layouts';
import { homeUrl } from '@urls';

const ServerErrorSVG = React.lazy(() =>
  import('assets/server-error.svg?react').then((m) => ({ default: m.default })),
);

export const ServerErrorView: React.FC<{
  backRef?: boolean;
  errorId: string[];
}> = ({ backRef = true, errorId }) => (
  <ServerErrorLayout
    image={
      <Suspense fallback={null}>
        <ServerErrorSVG />
      </Suspense>
    }
    headerText="Wewnętrzny błąd serwera"
    subHeaderText={
      <>
        <br />
        Spróbuj ponownie za kilka minut lub skontaktuj się z nami <HelpLink />. Przepraszamy za
        utrudnienia.
        <br />
        {!!errorId?.length && (
          <>
            Kod błędu: <strong>{errorId.join(',')}</strong>
          </>
        )}
      </>
    }
    backPath={backRef ? homeUrl : false}
    backText="Spróbuj ponownie"
  />
);
